import {
  type AiFieldCellLoadingState,
  AiFieldThinkingPlaceholder
} from '@databases/database-ai-fields';
import { DatabaseValueViewContainer } from '@databases/styles';
import React, { type FunctionComponent } from 'react';

import DatabaseValueView, { type DatabaseValueViewProps } from '../DatabaseValueView.tsx';

const AiSummaryFieldReadView: FunctionComponent<
  DatabaseValueViewProps & { loadingState: AiFieldCellLoadingState }
> = ({ contentId, fieldId, entryId, loadingState, ...props }) => {
  if (loadingState !== null) {
    return (
      <DatabaseValueViewContainer data-testid="database-value-view-container">
        <AiFieldThinkingPlaceholder loadingState={loadingState} />
      </DatabaseValueViewContainer>
    );
  }

  return (
    <DatabaseValueView
      {...props}
      contentId={contentId}
      fieldId={fieldId}
      entryId={entryId}
    />
  );
};

export default AiSummaryFieldReadView;
